import { useFormFlowContext } from "../../components/forms/FormFlowContext";
import FailedAuthLinkMessage from "../../components/messages/FailedAuthLinkMessage";
import appSettings from "../../settings/appSettings";

function useSendAuthLinkError() {
  const { setFormSuccess, setFormError, pageForward } = useFormFlowContext();
  const { wvusLogger } = appSettings;

  const onSendAuthLinkError =
    (messagePrefix = "", backView = "signin") =>
    (err) => {
      const errorMessage = `${messagePrefix}: ${err?.message || ""}`;
      const statusCode = err?.resp?.status || null;
      const errorReason = "send_auth_link_error";
      wvusLogger.log({ errorMessage, statusCode }, wvusLogger.getLogLevelNames().ERROR);
      setFormSuccess(false);

      setFormError({
        errorKey: "sendAuthLink",
        errorType: "auth0",
        errorCode: `${errorReason}${statusCode || "error"}`,
        saveError: true,
        AlertMessage: FailedAuthLinkMessage,
        errorBackData: {
          view: backView,
          currentPage: null
        }
      });
    };

  const onSendAuthLinkErrorPageForward =
    (messagePrefix = "") =>
    (err) => {
      const errorMessage = `${messagePrefix}: ${err?.message || ""}`;
      const statusCode = err?.resp?.status || null;
      wvusLogger.log({ errorMessage, statusCode }, wvusLogger.getLogLevelNames().ERROR);
      pageForward();
    };

  return {
    onSendAuthLinkError,
    onSendAuthLinkErrorPageForward
  };
}

export default useSendAuthLinkError;
